import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  GetAllActieScreens() {
    return Api().get(`/api/admin/getAllActiveScreens`);
  },
  GetScreens(payload) {
    // return Api().get(`/api/admin/tablelist/screens?screen_is_active=Y`)
    return Api().post(`/api/admin/activescreens`, payload);
  },
  GetMovies(payload) {
    let query = createQueryString(payload);
    // return Api().get(`/movie/movielist`)
    return Api().get(`/api/admin/getmovieslist${query}`);
  },

  //For viewscheduleDD-1
  GetMoviesDD(payload) {
    // return Api().get(`/movie/movielist`)
    let url = `/api/admin/getmovieslist?schedule=${payload.title}&type=${payload.tab}&cinema_id=${payload.cinema_id}`;
    if (payload.hasOwnProperty("isExcel")) {
      url += `&isExcel='Y'&macs_status=${payload.macs_status}`;
    }
    if (payload.hasOwnProperty("limit")) {
      url += `&currentPage=${payload.currentPage}&limit=${payload.limit}`;
    }
    if (payload.hasOwnProperty("maccs_search")) {
      url += `&maccs_search=${payload.maccs_search}`;
    }
    if (payload.hasOwnProperty("macs_status_filter")) {
      url += `&macs_status_filter=${payload.macs_status_filter}`;
    }
    if (payload.hasOwnProperty("orderBy")) {
      url += `&orderBy=${payload.orderBy}`;
    }
    return Api().get(url);
  },

  GetMoviesDDwithtransactiondate(payload) {
    // return Api().get(`/movie/movielist`)
    return Api().get(
      `/api/admin/getmovieslist?schedule=${payload.title}&type=${payload.tab}&cinema_id=${payload.cinema_id}&fromDate=${payload.fromDate}&toDate=${payload.toDate}&filter_with_key=${payload.filter_with_key}`
    );
  },
  GetCinemas() {
    return Api().get(`/admin/ms_cinemas`);
  },
  GetAllCinemaSettings(payload) {
    let cine_id =
      payload.cine_id && payload.cine_id.toString().length > 0
        ? payload.cine_id
        : "";
    if (
      payload &&
      payload.hasOwnProperty("searchValue") &&
      payload.hasOwnProperty("columnName")
    ) {
      return Api().get(
        `/api/admin/getallcinemasetting?cine_id=${cine_id}&searchValue=${payload.searchValue}&columnName=${payload.columnName}&orderBy=${payload.orderBy}`
      );
    } else {
      return Api().get(`/api/admin/getallcinemasetting?cine_id=${cine_id}`);
    }
  },
  GetCinemaSetting(payload) {
    return Api().get(`/api/admin/cinemasetting/${payload.cinema_id}`);
  },
  PostCinemaSetting(payload) {
    return Api().post(`/api/admin/postcinemasetting`, payload);
  },
  UpdateMoviesMaccsStatus(payload) {
    return Api().put(`/api/admin/update-macs-status`, payload);
  },
  AddCinemaSettings(payload) {
    return Api().post(`/api/admin/addcinemasettings`, payload);
  },
  UpdateCinemaSetting(payload) {
    return Api().put(`/api/admin/cinemasetting/${payload.cinema_id}`, payload);
  },
  GetRatecardByCinemaId: function(payload) {
    return Api().get(`/api/admin/scheduleratecard/${payload.cinema_id}`);
  },
  GetSeatTypesByScreenId(payload) {
    return Api().get(
      `/api/admin/tablelist/screen_seat_type?sst_is_active=Y&screen_id=${payload.screen_id}`
    );
  },
  GetAllActiveSchedule(payload) {
    return Api().post("/api/admin/getAllActiveSchedule", payload);
  },
  GetCinemaSchedule(payload) {
    // let ss_show_status=payload.ss_show_status==17?`&ss_show_status=${payload.ss_show_status}`:``;

    let ss_show_status = ``;
    if (payload.ss_show_status == 17 || payload.ss_show_status == 19) {
      ss_show_status = `&ss_show_status=${payload.ss_show_status}`;
    }
    return Api().get(
      `/api/admin/cinemaschedule/${payload.cinema_id}?start_date=${payload.start_date}&end_date=${payload.end_date}&groupbyssid=${payload.groupbyssid}${ss_show_status}&showPlanned=Y`
    );
  },
  GetAllCinemaSchedule(payload) {
    return Api().get(
      `/api/admin/allcinemaschedule/${payload.cinema_id}?start_date=${payload.start_date}&end_date=${payload.end_date}&ss_show_status=${payload.ss_show_status}&is_active=${payload.is_active}`
    );
  },
  UpdateCinemaScheduleByPrice(payload) {
    return Api().put(
      `/api/admin/scheduleshowprice/${payload.show_schedule_id}`,
      payload
    );
  },
  UpdateShowStatus(payload) {
    return Api().put(`/api/admin/cinemaschedule`, payload);
  },
  UpdateCinemaScheduleByShow(payload) {
    return Api().put(
      `/api/admin/scheduleshow/${payload.show_schedule_id}`,
      payload
    );
  },
  AddSchedule(payload) {
    return Api().post(`/api/admin/cinemaschedule`, payload);
  },
  AddMultiScheduleDD(payload) {
    return Api().post(`/api/admin/addmulti_schedule_dd`, payload);
  },

  GetShowTimebyMovie(payload) {
    return Api().post(`/api/admin/showtime`, payload);
  },
  addMultipleSchedule(payload) {
    return Api().post(`/api/admin/multicinema_schedule`, payload);
  },
  GetRatecardGroupByCinemaId(payload) {
    return Api().get(
      `/api/admin/scheduleratecardgroup/${payload.cinema_id}?is_private_rate_card=N`
    );
  },
  GetPrivateRatecardGroupByCinemaId(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/scheduleratecardgroup/${payload.cinema_id}`);
  },
  updateAdmits(payload) {
    return Api().post(`/api/qr-code/update-seat-status-qr-code`, payload);
  },
  deleteMultipleSchedule(payload) {
    return Api().put(`/api/admin/update_schedule_list`, payload);
  },
  GetScheduleOverview(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/all-confirmed-movies-schedules${qs}`);
  },
  ChechOverlapScheduleNew(payload) {
    return Api().post(`/api/admin/check-duplicate-schedule`, payload);
  },
  saveOverlapConflicts(payload) {
    return Api().post(`/api/admin/add-conflict-schedule`, payload);
  },
  ExportScheduleList(payload) {
    let qs = createQueryString(payload);
    return Api().get(`/api/admin/export_schedule_list${query}`);
  },
  CopyCinemaSchedule(payload) {
    return Api().post(`/api/admin/copyCinemaSchedule/${payload.cinema_id}/${payload.screen_id}`, payload);
  }
};



// WEBPACK FOOTER //
// ./src/services/scheduleService.js